/* unplugin-vue-components disabled */import { render } from "./MfConfirmDialog.vue?vue&type=template&id=62dfe01b&scoped=true"
import script from "./MfConfirmDialog.vue?vue&type=script&lang=js"
export * from "./MfConfirmDialog.vue?vue&type=script&lang=js"

import "./MfConfirmDialog.vue?vue&type=style&index=0&id=62dfe01b&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62dfe01b"]])

export default __exports__